import { render, staticRenderFns } from "./WalletStatusButton.vue?vue&type=template&id=856d8f8c&scoped=true&"
import script from "./WalletStatusButton.vue?vue&type=script&lang=ts&"
export * from "./WalletStatusButton.vue?vue&type=script&lang=ts&"
import style0 from "./WalletStatusButton.vue?vue&type=style&index=0&id=856d8f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d8f8c",
  null
  
)

export default component.exports